import { useQuery } from '@tanstack/react-query';
import { fetchEventDetail, fetchEventRsvps } from '../../api/events';
import { queryKeys } from '../../lib/query/queryKeys';
import { STALE } from '../../lib/query/staleTimes';
import { isPrefetchAllowed } from '../../lib/network/effectiveConnectivity';

export function useEventDetail(eventId) {
  return useQuery({
    queryKey: queryKeys.events.detail(eventId),
    queryFn: () => fetchEventDetail(eventId),
    enabled: Boolean(eventId),
    staleTime: STALE.semiStatic,
  });
}

export function useEventDetailRsvps(eventId) {
  return useQuery({
    queryKey: queryKeys.events.detailRsvps(eventId),
    queryFn: () => fetchEventRsvps(eventId),
    enabled: Boolean(eventId),
    staleTime: STALE.user,
  });
}

export function prefetchEventDetail(queryClient, eventId) {
  if (!eventId || !isPrefetchAllowed()) return;
  return queryClient.prefetchQuery({
    queryKey: queryKeys.events.detail(eventId),
    queryFn: () => fetchEventDetail(eventId),
    staleTime: STALE.semiStatic,
  });
}
